export class Utils {
    public static setHost(endpoint: string, url: string): string {
        return endpoint + url;
    }
}
